var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "q-form",
    { ref: "editForm" },
    [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
        [
          _c(
            "c-card",
            {
              staticClass: "cardClassDetailForm",
              attrs: { title: "기본정보" },
            },
            [
              _c(
                "template",
                { slot: "card-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _c("c-btn", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.disabled,
                            expression: "!disabled",
                          },
                        ],
                        attrs: {
                          url: _vm.updateUrl,
                          isSubmit: _vm.isSave,
                          param: _vm.accidentInfo,
                          mappingType: "PUT",
                          label: "기본정보 저장",
                          icon: "save",
                        },
                        on: {
                          beforeAction: _vm.saveAccident,
                          btnCallback: _vm.saveCallback,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("template", { slot: "card-detail" }, [
                _c(
                  "div",
                  {
                    staticClass: "col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4",
                  },
                  [
                    _c("c-textarea", {
                      attrs: {
                        editable: _vm.editable,
                        disabled: _vm.disabled,
                        rows: 5,
                        label: "재해발생원인(인적)",
                        name: "accidentCause",
                      },
                      model: {
                        value: _vm.accidentInfo.accidentCause,
                        callback: function ($$v) {
                          _vm.$set(_vm.accidentInfo, "accidentCause", $$v)
                        },
                        expression: "accidentInfo.accidentCause",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4",
                  },
                  [
                    _c("c-textarea", {
                      attrs: {
                        editable: _vm.editable,
                        disabled: _vm.disabled,
                        rows: 5,
                        label: "재해발생원인(물적)",
                        name: "accidentCauseM",
                      },
                      model: {
                        value: _vm.accidentInfo.accidentCauseM,
                        callback: function ($$v) {
                          _vm.$set(_vm.accidentInfo, "accidentCauseM", $$v)
                        },
                        expression: "accidentInfo.accidentCauseM",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4",
                  },
                  [
                    _c("c-textarea", {
                      attrs: {
                        editable: _vm.editable,
                        disabled: _vm.disabled,
                        rows: 5,
                        label: "재해발생원인(환경적)",
                        name: "accidentCauseE",
                      },
                      model: {
                        value: _vm.accidentInfo.accidentCauseE,
                        callback: function ($$v) {
                          _vm.$set(_vm.accidentInfo, "accidentCauseE", $$v)
                        },
                        expression: "accidentInfo.accidentCauseE",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4",
                  },
                  [
                    _c("c-textarea", {
                      attrs: {
                        editable: _vm.editable,
                        disabled: _vm.disabled,
                        rows: 5,
                        label: "재발방지대책(공학적)",
                        name: "engineeringRecurrence",
                      },
                      model: {
                        value: _vm.accidentInfo.engineeringRecurrence,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.accidentInfo,
                            "engineeringRecurrence",
                            $$v
                          )
                        },
                        expression: "accidentInfo.engineeringRecurrence",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4",
                  },
                  [
                    _c("c-textarea", {
                      attrs: {
                        editable: _vm.editable,
                        disabled: _vm.disabled,
                        rows: 5,
                        label: "재발방지대책(관리적)",
                        name: "managementRecurrence",
                      },
                      model: {
                        value: _vm.accidentInfo.managementRecurrence,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.accidentInfo,
                            "managementRecurrence",
                            $$v
                          )
                        },
                        expression: "accidentInfo.managementRecurrence",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4",
                  },
                  [
                    _c("c-textarea", {
                      attrs: {
                        editable: _vm.editable,
                        disabled: _vm.disabled,
                        rows: 5,
                        label: "환경안경팀 의견",
                        name: "managerOpinion",
                      },
                      model: {
                        value: _vm.accidentInfo.managerOpinion,
                        callback: function ($$v) {
                          _vm.$set(_vm.accidentInfo, "managerOpinion", $$v)
                        },
                        expression: "accidentInfo.managerOpinion",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "c-table",
        {
          ref: "tableImpr",
          attrs: {
            title: "수시 위험성평가",
            columns: _vm.gridImpr.columns,
            data: _vm.accidentInfo.accidentImproveModelList,
            gridHeight: _vm.gridHeight,
            merge: _vm.gridImpr.merge,
            selection: "multiple",
            rowKey: "causesNo",
            usePaging: false,
            hideBottom: true,
            filtering: false,
            columnSetting: false,
            editable: _vm.editable && !_vm.disabled,
          },
          on: { "table-data-change": _vm.tableDataChange },
          scopedSlots: _vm._u([
            {
              key: "customArea",
              fn: function ({ props, col }) {
                return [
                  col.name === "customCol"
                    ? [
                        _c(_vm.imprComponent, {
                          tag: "component",
                          attrs: {
                            col: col,
                            props: props,
                            inputEditable: _vm.editable && !_vm.disabled,
                            isImmShow: true,
                            tableKey: "causesNo",
                            ibmTaskTypeCd: "ITT0000040",
                            ibmTaskUnderTypeCd: "ITTU000065",
                            requestContentsCols: [
                              "accidentName",
                              "causeTypeName",
                              "accidentCause",
                              "riskLevelNameB",
                              "riskLevelNameA",
                              "improvingMeasures",
                            ],
                          },
                          on: { imprChange: _vm.imprChange },
                        }),
                      ]
                    : _vm._e(),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "table-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _vm.editable && !_vm.disabled
                    ? _c("c-btn", {
                        attrs: {
                          label: "LBLADD",
                          showLoading: false,
                          icon: "add",
                        },
                        on: { btnClicked: _vm.addImpr },
                      })
                    : _vm._e(),
                  _vm.editable &&
                  !_vm.disabled &&
                  _vm.accidentInfo.accidentImproveModelList.length > 0
                    ? _c("c-btn", {
                        attrs: {
                          url: _vm.updateCauseUrl,
                          isSubmit: _vm.isSave2,
                          param: _vm.accidentInfo.accidentImproveModelList,
                          mappingType: "PUT",
                          label: "LBLSAVE",
                          icon: "save",
                        },
                        on: {
                          beforeAction: _vm.saveImpr,
                          btnCallback: _vm.saveCallback,
                        },
                      })
                    : _vm._e(),
                  _vm.editable &&
                  !_vm.disabled &&
                  _vm.accidentInfo.accidentImproveModelList.length > 0
                    ? _c("c-btn", {
                        attrs: {
                          label: "LBLREMOVE",
                          showLoading: false,
                          icon: "remove",
                        },
                        on: { btnClicked: _vm.removeImpr },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "c-card",
        {
          staticClass: "cardClassDetailForm accident",
          attrs: { title: "위험성 판단 기준", height: "220px" },
        },
        [
          _c("template", { slot: "card-detail" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
              },
              [
                _c("table", { staticClass: "riskCriteriaTable" }, [
                  _c("thead", [
                    _c("tr", [
                      _c("th", { staticStyle: { width: "16%" } }, [
                        _vm._v("위험성 수준"),
                      ]),
                      _c("th", [_vm._v("판단 기준")]),
                      _c("th", { staticStyle: { width: "15%" } }, [
                        _vm._v("허용 가능 여부"),
                      ]),
                    ]),
                  ]),
                  _c("tbody", [
                    _c("tr", [
                      _c("td", { staticClass: "riskLevelCell riskLevelHigh" }, [
                        _c("b", { staticClass: "text-red q-mr-sm" }, [
                          _vm._v("상(빨강)"),
                        ]),
                        _vm._v(": 매우높음"),
                      ]),
                      _c("td", { staticClass: "riskCriteriaCell" }, [
                        _vm._v(
                          " · 사고 발생 시 사망 또는 장애가 남을 수 있는 위험"
                        ),
                        _c("br"),
                        _vm._v(
                          " · 산업안전보건법에 따른 기준을 만족시키지 못한 경우 "
                        ),
                      ]),
                      _c("td", { attrs: { rowspan: "2" } }, [
                        _vm._v("허용 불가능"),
                        _c("br"),
                        _vm._v("(개선 후 작업)"),
                      ]),
                    ]),
                    _c("tr", [
                      _c("td", { staticClass: "riskLevelCell riskLevelMid" }, [
                        _c("b", { staticClass: "text-amber q-mr-sm" }, [
                          _vm._v("중(노랑)"),
                        ]),
                        _vm._v(": 보통"),
                      ]),
                      _c("td", { staticClass: "riskCriteriaCell" }, [
                        _vm._v(" · 사고 발생 시 3일 이상의 휴업이 필요한 경우"),
                        _c("br"),
                        _vm._v(" · 아차사고 사례가 있는 경우 "),
                      ]),
                    ]),
                    _c("tr", [
                      _c("td", { staticClass: "riskLevelCell riskLevelLow" }, [
                        _c("b", { staticClass: "text-green q-mr-sm" }, [
                          _vm._v("하(초록)"),
                        ]),
                        _vm._v(": 매우낮음"),
                      ]),
                      _c("td", { staticClass: "riskCriteriaCell" }, [
                        _vm._v(
                          " · 3일 미만의 휴업 또는 작업 수행에 영향을 미치지 않는 경미한 부상 또는 질병이 예상되는 경우 "
                        ),
                      ]),
                      _c("td", [_vm._v("허용가능")]),
                    ]),
                  ]),
                ]),
              ]
            ),
          ]),
        ],
        2
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }